import { TransactionType } from "../shared/enum";

export interface JanTransactionBillingObject {
    janTransactionBillingPagedList: JanTransactionBillingPagedList[];
    countJANTransactionBillingList: number;
    TotalRecords: number;
    TotalChecked: number;
    TotalUnchecked: number;
    CheckedPercent: string;
    UncheckedPercent: string;
    TotalAmount: string;
    Ids: Id[];
}

export interface TransactionList {
    Url?: string;
    agentCode: string;
    accOffCode: string;
    paymentFrom: Date;
    paymentTo: Date;
    sqlPNR: string;
    pukalNo: string;
    travelAgent: string;
    warrantNumber: string;
    recordStatus: string;
    page: number;
    isSplitBooking: string;
    invoiceNo: string;
    PageSize: number;
    transactionType: TransactionType
}

export interface JanTransactionBillingPagedList {
    RowNumber: number;
    Bill_Id: number;
    Bill_Pnr: string;
    Bill_Parent_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj: number;
    Bill_Pymnt_Dt: Date;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_Rcd_Sts: string;
    Bill_Tran_Check: boolean;
    Bill_Inv_No: number;
    Split_Booking: string;
    Remark: string;
    Last_Exported_By: string;
}

export interface NgrTransactionBillingbject {
    ngrTransactionBillingPagedList: NgrTransactionBillingPagedList[];
    countNGRTransactionBillingList: number;
    TotalRecords: number;
    TotalChecked: number;
    TotalUnchecked: number;
    CheckedPercent: string;
    UncheckedPercent: string;
    TotalAmount: string;
    Ids: Id[];
}

export interface NgrTransactionBillingPagedList {
    RowNumber: number;
    Bill_Id: number;
    Bill_Pnr: string;
    Bill_Parent_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj: number;
    Bill_Pymnt_Dt: Date;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_Rcd_Sts: string;
    Bill_Tran_Check: boolean;
    Bill_Inv_No: number;
    Split_Booking: string;
    Remark: string;
}

export interface SwkTransactionBillingObject {
    swkTransactionBillingPagedList: SwkTransactionBillingPagedList[];
    countSwkTransactionBillingList: number;
    TotalRecords: number;
    TotalChecked: number;
    TotalUnchecked: number;
    CheckedPercent: string;
    UncheckedPercent: string;
    TotalAmount: string;
    Ids: Id[];
}

export interface SwkTransactionBillingPagedList {
    RowNumber: number;
    Bill_Id: number;
    Bill_Pnr: string;
    Bill_Parent_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj: number;
    Bill_Pymnt_Dt: Date;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_Rcd_Sts: string;
    Bill_Tran_Check: boolean;
    Bill_Inv_No: number;
    Split_Booking: boolean;
    Remark: string;
}

export interface Id {
    Id: string;
    BillId: string;
    IsChecked: boolean;
}

export interface AccountOffice {
    Acc_Off_Code: number;
    Acc_Off: string;
}

export interface AgentCode {
    Airline_Agency_Code: string;
    Agency_Name: string;
}

export interface RecordStatus {
    Rcd_Sts_Code: number;
    Rcd_Sts: string;
}

export interface TransactionFieldObject {
    agentCode?: any;
    accOffCode?: any;
    paymentFrom: Date;
    paymentTo: Date;
    sqlPNR?: any;
    pukalNo?: any;
    travelAgent?: any;
    warrantNumber?: any;
    recordStatus?: any;
    janTransactionBillingList?: any;
    accountOffices: AccountOffice[];
    agentCodes: AgentCode[];
    recordStatuses: RecordStatus[];
    page: number;
}

export interface UpdateCheckedTransObject {
    TotalRecords: number;
    TotalChecked: number;
    TotalUnchecked: number;
    CheckedPercent: string;
    UncheckedPercent: string;
    TotalAmount: string;
}

export interface ParentPnrObject {
    Pnr: string;
}

export interface SelectModel {
    value: string;
    viewValue: string;
}

export interface SummaryFieldElement {
    name: string;
    LineCount: string;
    Percentage: string;
}

export class TransactionDetail {
    Bill_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj_Id: number;
    Bill_Pymnt_Dt: Date;
    Bill_Pymnt_Type: string;
    Bill_Currency_Code: string;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Insurance: number;
    Bill_Admin_Fee: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_No_Luran_Wajib_Jasa: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_06_Pymnt: number;
    Bill_Tran_Check: boolean;
    Bill_Inv_No: number;
    Bill_Others_Pymnt: number;
    Bill_Sys_Date: Date;
    Bill_Rcd_Sts_Code: any;    //byte
    Bill_Id: number;
    Acc_Airline_Agency_Code: string;
    Acc_Warrant_Auth_Code: string;
    Acc_Acc_Off_Code: number;
    Acc_Project: string;
    Acc_Acc_Sts_Code: any;    //byte
    Acc_Rcd_Sts_Code: number;
    Acc_Acc_No: string;
    Acc_Acc: string;
    Bill_Obj: any;    //byte
    Bill_Rcd_Sts: string;
    FTP_GPG_Recipient: string;
    FTP_IP_Addr: string;
    FTP_User_Id: string;
    FTP_Password: string;
    Split_Booking: boolean;
    Remark: string;
    TransObjects = [];
}

export interface TransObject {
    Obj_Id: number;
    Obj_Id_Map: number;
}

export interface TransactionDetailObject {
    Bill_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj_Id: number;
    Bill_Pymnt_Dt: Date;
    Bill_Pymnt_Type: string;
    Bill_Currency_Code: string;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Insurance: number;
    Bill_Admin_Fee: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_No_Luran_Wajib_Jasa: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_06_Pymnt: number;
    Bill_Tran_Check: boolean;
    Bill_Inv_No?: any;
    Bill_Others_Pymnt: number;
    Bill_Sys_Date: Date;
    Bill_Rcd_Sts_Code: number;
    Bill_Id: number;
    Acc_Airline_Agency_Code: string;
    Acc_Warrant_Auth_Code: string;
    Acc_Acc_Off_Code: number;
    Acc_Project: string;
    Acc_Acc_Sts_Code: number;
    Acc_Rcd_Sts_Code: number;
    Acc_Acc_No: string;
    Acc_Acc: string;
    Bill_Obj: number;
    Bill_Rcd_Sts: string;
    FTP_GPG_Recipient: string;
    FTP_IP_Addr: string;
    FTP_User_Id: string;
    FTP_Password: string;
    Split_Booking: boolean;
    Remark?: any;
    TransObjects: TransObject[];
}

export interface TransactionDT {
    Acc_No: string;
    Admin_Fee: number;
    Agency_Code: string;
    Air_Port_Tax: number;
    Aline_Id: string;
    Base_Fare_Amt: number;
    Booking_Dt: string;
    Check: boolean;
    Currency_Code: string;
    Fuel_Surcharge: number;
    ID: number;
    Insurance: number;
    No_Luran_Wajib_Jasa: number;
    Obj: string;
    Obj_Id: number;
    Pnr: string;
    Psg_First_Name: string;
    Psg_Last_Name: string;
    Pymnt_Amt: number;
    Pymnt_Dt: string;
    Pymnt_Type: string;
    Sec_1: string;
    Sec_2: string;
    Serial_No: string;
    Services_Charge: number;
    Title: string;
    Vat: number;
}

export interface TransactionObject {
    Obj_Id: number;
    Obj_Id_Map: number;
}

export interface editFormModel {
    pukalnumber: string;
    billserialno: string;
    selectedobject: number;
    basefare: number;
    airporttax: number;
    insurance: number;
    adminfee: number;
    vat: number;
    fuelsurcharge: number;
    noluranwajibjasa: number;
    servicescharge: number;
    paymentamount: number;
}

export interface editAccountObject {
    Airline_Agency_Code: string;
    Agency_Name: string;
    Warrant_Auth_Code: string;
    Acc_Off_Code: number;
    Acc_Off: string;
    Acc_No: string;
    Acc: string;
    Billing_Day: number;
    Sort_Key: number;
    Warrant_RCCC: string;
    Warrant_Dept: string;
    Vote: string;
    Charge_Dept: string;
    Charge_RCCC: string;
    Program: string;
    Project: string;
    CP: string;
    Object: number;
    Obj: string;
    Acc_Sts_Code: number;
    Acc_Sts: string;
    Rcd_Sts_Code: number;
    Rcd_Sts: string;
    Creation_Date: string;
    Activation_Date: string;
    Termination_Date: string;
    Sys_Date: string;
    User_Id: string;
    Cnt_Code: string;
    Created_User_Id: string;
    Created_Cnt_Code: string;
    TransObjects: TransObject[];
    Setia?: any;
}

export interface OthTransactionBillingObject {
    othTransactionBillingPagedList: OthTransactionBillingPagedList[];
    countOTHTransactionBillingList: number;
    TotalRecords: number;
    TotalChecked: number;
    TotalUnchecked: number;
    CheckedPercent: string;
    UncheckedPercent: string;
    TotalAmount: string;
    Ids: Id[];
}

export interface OthTransactionBillingPagedList {
    RowNumber: number;
    Bill_Id: number;
    Bill_Pnr: string;
    Bill_Parent_Pnr: string;
    Bill_Booking_Dt: Date;
    Bill_Agency_Code: string;
    Bill_Acc_No: string;
    Bill_Serial_No: string;
    Bill_Obj: string;
    Bill_Pymnt_Dt: Date;
    Bill_Base_Fare_Amt: number;
    Bill_Air_Port_Tax: number;
    Bill_Vat: number;
    Bill_Fuel_Surcharge: number;
    Bill_Services_Charge: number;
    Bill_Pymnt_Amt: number;
    Bill_Rcd_Sts: string;
    Bill_Tran_Check: boolean;
    Bill_Inv_No: string;
    Split_Booking: string;
    Remark: string;
}